module.exports = __webpack_public_path__ + "img/d201101-1.d5f1c299.jpg";